






























































import Vue from 'vue';
import Component from 'vue-class-component';
import SignInDialog from '@/components/Auth/SignInDialog.vue';

@Component({
  components: {SignInDialog}
})
export default class HomeJoinSocialLeague extends Vue {
  dialog = false

  calculateSectionHeight(): string {
    const height = this.$vuetify.breakpoint.height;
    const {sm} = this.$vuetify.breakpoint.thresholds;
    if (height >= sm) {
      return '100vh'
    } else {
      return '100%'
    }
  }
}
